import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'reports-tooltip-footer',
  styleUrls: ['./report-tooltip-footer.component.less'],
  imports: [],
  template: `
    <div class="primary">{{ primarySlotText() }}</div>
    <div class="secondary">{{ secondarySlotText() }}</div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportTooltipFooterComponent {
  public readonly primarySlotText = input<string>();
  public readonly secondarySlotText = input<string>();
}
